/* global translations */
import React, { Component } from 'react';
import get from 'lodash/get';
import DeleteMeActionCreators from '../../actions/DeleteMeActionCreators';
import DeleteMeStore from '../../stores/DeleteMeStore';
import DeleteMeTitle from '../../components/settings/DeleteMeTitle';
import DeleteMePassword from '../../components/settings/DeleteMePassword';
import DeleteMeReason from '../../components/settings/DeleteMeReason';
import modal from '../../../legacy/app/modal';

class DeleteMeContainer extends Component {
  state = {
    password: DeleteMeStore.getPassword(),
    passwordError: DeleteMeStore.getPasswordError(),
    reasonQuestion: DeleteMeStore.getReasonQuestion(),
    selectedReason: DeleteMeStore.getSelectedReason(),
    email: DeleteMeStore.getEmail(),
    emailFieldName: DeleteMeStore.getEmailFieldName(),
    emailError: DeleteMeStore.getEmailError(),
  };

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeunload);
    DeleteMeStore.addChangeListener(this.onChange);

    DeleteMeActionCreators.loadDeleteMeData();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeunload);
    DeleteMeStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      password: DeleteMeStore.getPassword(),
      passwordError: DeleteMeStore.getPasswordError(),
      reasonQuestion: DeleteMeStore.getReasonQuestion(),
      selectedReason: DeleteMeStore.getSelectedReason(),
      email: DeleteMeStore.getEmail(),
      emailFieldName: DeleteMeStore.getEmailFieldName(),
      emailError: DeleteMeStore.getEmailError(),
    });
  };

  handleBeforeunload = (e) => {
    e.preventDefault();
    e.returnValue = '';
  };

  handlePasswordChange = (e) => {
    DeleteMeStore.setPassword(e.target.value);
    DeleteMeStore.setPasswordError('');
    DeleteMeStore.emitChange();
  };

  handleEmailChange = (e) => {
    DeleteMeStore.setEmail(e.target.value);
    DeleteMeStore.setEmailError('');
    DeleteMeStore.emitChange();
  };

  handleSelectReason = (e) => {
    DeleteMeStore.setSelectedReason(e.target.value);
    DeleteMeStore.emitChange();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { password, selectedReason } = this.state;
    if (!password || !selectedReason) {
      const message = 'txt: Lai dzēstu savu profilu, jābūt ievadītai parolei un izvēlētam profila dzēšanas iemeslam';
      modal.alert(get(translations, message, message), get(translations, 'txt: Sapratu', 'txt: Sapratu'));
      return;
    }

    window.removeEventListener('beforeunload', this.handleBeforeunload);
    e.currentTarget.submit();
  };

  render() {
    const {
      password,
      passwordError,
      reasonQuestion,
      selectedReason,
      email,
      emailFieldName,
      emailError,
    } = this.state;

    return (
      <div>
        <DeleteMeTitle />
        <div className="settingsForm group block">
          <form
            id="MembersDelete"
            action="/settings/delete_me"
            method="post"
            onSubmit={this.handleSubmit}
          >
            <div className="g-b g-b--1of2">
              <DeleteMePassword
                value={password}
                error={passwordError}
                onChange={this.handlePasswordChange}
              />
            </div>
            <DeleteMeReason
              reasonQuestion={reasonQuestion}
              onReasonChange={this.handleSelectReason}
              selectedReason={selectedReason}
              emailFieldName={emailFieldName}
              onEmailChange={this.handleEmailChange}
              email={email}
              emailError={emailError}
            />
            <button
              type="submit"
              className="btn btn--a fr mbl"
            >
              {get(translations, 'txt: Dzēst profilu', '')}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default DeleteMeContainer;
